/* eslint-disable eqeqeq */
/* eslint-disable jsdoc/require-returns */
import * as React from 'react';

import { AppContext } from '../App';

import DTAdsMemberView from './DTAdsMemberView';
import DTAdsRestrictedView from './DTAdsRestrictedView';

const pluginURL = window.pbc_facet_options.pluginURL;

/**
 *  @name DealTrackerAds
 */
export const DealTrackerAds: React.FC = () => {
	const app = React.useContext( AppContext );
	const [ isRestricted, setIsRestricted ] = React.useState<boolean>( true );

	React.useEffect( () => {
		if ( String( app?.props?.wpProps?.subscription_required || '1' ) !== '0' ) {
			setIsRestricted( true );
		} else {
			setIsRestricted( false );
		}
	}, [ app ] );

	return (
		<div className="dt-ads">
			<div className="dt-ads__content">
				<div className="dt-ads__content-image">
					<picture>
						<source srcSet={ `${pluginURL}src/assets/dt-ads-web.png` } media="(min-width: 580px)" />
						<img src={ `${pluginURL}src/assets/dt-ads-mobile.png` } alt="Deal Tracker app screenshots displayed on mobile devices" />
					</picture>
				</div>

				<div className="dt-ads__content-bg">
					{ isRestricted ? <DTAdsRestrictedView /> : <DTAdsMemberView /> }
				</div>
			</div>
		</div>
	);
};
